import { SearchOutlined } from '@ant-design/icons'
import { css } from '@emotion/react'
import { TraceKeyResponseTypeEnum } from '@ulysses-inc/harami_api_client'
import { Flex, Input, Typography } from 'antd'
import { TraceKeyConditionFilter } from 'src/features/reports/listBetaFilters/drawer/hooks/useTraceKeyFilter'

const { Text } = Typography

type ResponseSetTraceKeyFilter = Extract<
  TraceKeyConditionFilter,
  { responseType: TraceKeyResponseTypeEnum.ResponseSet }
>

type Props = {
  filter: ResponseSetTraceKeyFilter
  onChange: (newFilter: ResponseSetTraceKeyFilter) => void
  showError: boolean
}

export const ResponseSetTraceKeyFilter = ({
  filter,
  onChange,
  showError,
}: Props) => {
  const hasError = !filter.responseSet?.value
  const shouldShowError = showError && hasError

  return (
    <Flex vertical gap={4}>
      <Input
        allowClear
        count={{
          max: 15,
          show: true,
          strategy: (txt: string) => [...txt].length,
          exceedFormatter: (txt, { max }) => [...txt].slice(0, max).join(''),
        }}
        onChange={e =>
          onChange({
            ...filter,
            responseSet: { value: e.target.value },
          })
        }
        placeholder={`${filter.traceKeyName}を入力してください`}
        value={filter.responseSet?.value}
        suffix={<SearchOutlined />}
        status={shouldShowError ? 'error' : undefined}
      />
      {shouldShowError && (
        <Text type="danger" css={styles.errorText}>
          検索キーの値を入力してください
        </Text>
      )}
    </Flex>
  )
}

const styles = {
  errorText: css`
    font-size: 12px;
  `,
}
